export default "__VITE_ASSET__CJ5lGmgE__"